module.exports = __webpack_public_path__ + "img/36.e7c1ce60.jpg";